import { isResponseError } from "../api/responseError";

// Preview error contract shared by both apps: thrown/checked around document preview fetches.
// The status codes mirror the backend's preview endpoint responses.
export class PreviewNotImplementedError extends Error {}

export const PreviewStatusCode = {
  NotReady: 422,
  Failed: 409,
};

export function isPreviewNotReadyError(error: unknown): boolean {
  return isResponseError(error) && error.response.status === PreviewStatusCode.NotReady;
}
